import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function WysiwygTextField(props) {
  return <Editor {...props} />;
}
